'use client'

import { useEffect } from 'react'
import { I18nextProvider } from 'react-i18next'
import { getI18nInstance } from '../app/i18n/instances'

// Provides the locale-locked i18n instance to everything under a `[lang]` route, so client
// components' `useTranslation()` resolves that locale's strings during SSR and on the client.
// `translation` is that locale's strings, from the `[lang]` layout (a server component), so the
// browser receives one language rather than all ten. `getI18nInstance` builds an instance once
// per locale and then returns it, so calling it in render is safe.
export function LocaleI18nProvider({ lang, translation, children }) {
  const instance = getI18nInstance(lang, translation)

  // The shared root `<html lang>` is statically "en"; sync it to the active locale on the
  // client so assistive tech / JS crawlers see the right language. (Full SSR `<html lang>`
  // would require moving the whole app under `[lang]`.)
  useEffect(() => {
    if (typeof document !== 'undefined') document.documentElement.lang = lang
  }, [lang])

  return <I18nextProvider i18n={instance}>{children}</I18nextProvider>
}
